import AccountDropdown from '@shared/components/navigation/nav-bars/components/account-dropdown';
import Chip from '@shared/components/chips';
import { Icon, IconNames } from '@shared/components/icons';
import { html } from '@shared/utils/rendering/html';

import { ERMPortalUrls } from '../../constants/routing/urls.constants';
import { Roles } from '../../constants/security/roles.constants';

import { IncludeSystem } from './system-utils.config';
import { Systems } from '../../constants/security/systems.constants';

const isOffline = (systemStatuses, key) =>
    systemStatuses?.[key] != null && systemStatuses[key].isActive === false;

const offlineLabel = (text) => ({
    text,
    antecedent: html`<${Chip} type="status-chip" css="bg-grey" label=${{ text: 'Offline' }} />`,
});

export const GenerateHomeOptions = (user, featureCheck, systemStatuses = {}) => {
    const options = [];

    if (IncludeSystem(Systems.RDARR, user, featureCheck)) {
        const offline = isOffline(systemStatuses, 'rdarr');
        options.push({
            label: offline ? offlineLabel('RDARR') : { text: 'RDARR' },
            props: { href: ERMPortalUrls.rdarr, disabled: offline },
        });
    }

    if (IncludeSystem(Systems.EWIS, user, featureCheck)) {
        const offline = isOffline(systemStatuses, 'ewis');
        options.push({
            label: offline ? offlineLabel('EWIS') : { text: 'EWIS' },
            props: { href: ERMPortalUrls.ewis, disabled: offline },
        });
    }

    if (IncludeSystem(Systems.Indicators, user, featureCheck)) {
        const offline = isOffline(systemStatuses, 'indicators');
        options.push({
            label: offline ? offlineLabel('Indicators') : { text: 'Indicators' },
            props: { href: ERMPortalUrls.indicatorMicroservice, disabled: offline },
        });
    }

    if (IncludeSystem(Systems.RiskAppetite, user, featureCheck)) {
        const offline = isOffline(systemStatuses, 'riskappetite');
        options.push({
            label: offline ? offlineLabel('Risk Appetite') : { text: 'Risk Appetite' },
            props: { href: ERMPortalUrls.riskAppetite, disabled: offline },
        });
    }

    if (IncludeSystem(Systems.RiskCulture, user, featureCheck)) {
        const offline = isOffline(systemStatuses, 'riskculture');
        options.push({
            label: offline ? offlineLabel('Risk Culture') : { text: 'Risk Culture' },
            props: { href: ERMPortalUrls.riskCulture, disabled: offline },
        });
    }

    return options;
};

export const GenerateHomeDefaultConfig = (userConfig, user) => {
    const options = [
        {
            icon: html`<${Icon} name=${IconNames.Badge} style="rounded" />`,
            props: { href: ERMPortalUrls.myAccess, target: '_blank' },
        },
        {
            icon: html`<${Icon} name=${IconNames.Help} style="rounded" />`,
            props: { href: ERMPortalUrls.technicalSupport, target: '_blank' },
        },
    ];

    if (user?.roles?.includes(Roles.Admin) || user?.roles?.includes(Roles.Developer)) {
        options.push({
            icon: html`<${Icon} name=${IconNames.Settings} style="rounded" />`,
            props: { href: ERMPortalUrls.admin },
        });
    }

    if (userConfig) {
        options.push({
            icon: null,
            render: html`<${AccountDropdown} settings=${userConfig} />`,
        });
    }

    return options;
};
